import { request } from "services/api/util";

class StoresByRetailerService {
  async getListStoresByRetailer(param) {
    const config = {
      method: "get",
      url: `admin/storeByRetailer`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}
export default new StoresByRetailerService();
